import { z } from "zod";
export const outboxStatusSchema = z.enum(["PENDING", "RUNNING", "DONE", "FAILED"]);
export const outboxTaskSchema = z.object({
    id: z.string(),
    type: z.string(),
    payload: z.record(z.string(), z.unknown()),
    status: outboxStatusSchema,
    attempts: z.number(),
    maxAttempts: z.number(),
    nextAttemptAt: z.number(),
    lastAttemptAt: z.number().nullable(),
    lastError: z.string().nullable(),
    createdAt: z.number(),
    doneAt: z.number().nullable(),
    enqueuedByUid: z.string().nullable(),
    context: z.record(z.string(), z.unknown()).nullable(),
});
